
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M15.001 30C23.285 30 30 23.285 30 15.001s-6.715-15-14.999-15-15 6.716-15 15c0 8.284 6.716 14.999 15 14.999z","fill":"#FF305C"}}),_c('path',{attrs:{"d":"M10.378 16.911v6.303h2.962V16.73l-2.962.181z","fill":"#262626"}}),_c('path',{attrs:{"d":"M16.645 6.68v6.917H13.34V9.694h-2.962v3.9l-3.004.026 3.004 2.834H17.8l-1.156.072v3.695h2.992V6.681h-2.992z","fill":"#262626"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h30v30H0z"}})])])])
          )
        }
      }
    